import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Hero from './components/Hero'; // still used in HomePage but keep lints satisfied if tree shaking
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import PricingPackages from './components/PricingPackages';
import FAQ from './components/FAQ';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LiveChat from './components/LiveChat';
import SEOHelmet from './components/SEOHelmet';
// Static pages
import About from './components/pages/About';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsOfService from './components/pages/TermsOfService';
import Support from './components/pages/Support';
import HomePage from './components/pages/HomePage';
import { LanguageProvider } from './i18n';

function App() {
    return (
        <HelmetProvider>
            <LanguageProvider>
              <Router>
                <div className="App">
                    <SEOHelmet />
                    <Header />

                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route path="/support" element={<Support />} />
                    </Routes>

                    <Footer />
                    {/* <LiveChat /> */}
                </div>
              </Router>
            </LanguageProvider>
        </HelmetProvider>
    );
}

export default App;
